module.exports = __webpack_public_path__ + "img/金色阿富汗.9677446a.png";